import styled from "styled-components";

const ContenedorHeader = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

const Header = styled.div`
    background: #fff; /* Color de fondo del header */
    width: 90%;
    margin: 3rem 0 2rem 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
`;
 
const Titulo = styled.h1`
    font-weight: normal;
    font-size: 1.2rem; /* 22.4px */
    color: #0f265c;
    margin: 0;
`;
 

 
const ContenedorBotones = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

export {Header, Titulo, ContenedorHeader, ContenedorBotones};
